
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CertificateDiscrepancyAlertProps {
  discrepancyCount: number;
  onResolveClick: () => void;
}

export function CertificateDiscrepancyAlert({ 
  discrepancyCount, 
  onResolveClick 
}: CertificateDiscrepancyAlertProps) {
  if (discrepancyCount === 0) {
    return (
      <Alert className="bg-green-50 border-green-200 mb-4">
        <CheckCircle className="h-4 w-4 text-green-600" />
        <AlertTitle className="text-green-800">All certificates accounted for</AlertTitle>
        <AlertDescription className="text-green-700">
          All certificates are properly reported and verified. No discrepancies found.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert className="bg-amber-50 border-amber-200 mb-4">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertTitle className="text-amber-800">Certificate Discrepancies Detected</AlertTitle>
      <AlertDescription className="text-amber-700 flex justify-between items-center">
        <span>
          Found {discrepancyCount} certificate{discrepancyCount !== 1 ? 's' : ''} that need{discrepancyCount === 1 ? 's' : ''} attention. 
          These certificates have inconsistent reporting or verification status.
        </span>
        <Button 
          size="sm"
          variant="outline"
          className="border-amber-500 text-amber-700 hover:bg-amber-100"
          onClick={onResolveClick}
        >
          Resolve Issues
        </Button>
      </AlertDescription>
    </Alert>
  );
}
